const ADS_LEVEL_NUM_FIELDS = [
  'spend',
  'impressions',
  'clicks',
  'link_clicks',
  'reach',
  'conversions',
  'revenue',
  'attributed_revenue',
  'add_to_cart',
  'initiate_checkout',
  'landing_page_views',
  'engagements',
  'parent_adset_revenue',
];

const round = (value, digits = 2) => Number((Number(value) || 0).toFixed(digits));

const aggregateAdsLevelRows = (rows = []) => {
  if (!rows.length) return [];

  const grouped = new Map();

  rows.forEach((row) => {
    const key = row.ad_id || row.ad_name || '';
    if (!key) return;
    if (!grouped.has(key)) {
      const base = { ...row };
      ADS_LEVEL_NUM_FIELDS.forEach((field) => { base[field] = 0; });
      grouped.set(key, base);
    }
    const acc = grouped.get(key);
    ADS_LEVEL_NUM_FIELDS.forEach((field) => {
      acc[field] += Number(row[field]) || 0;
    });
    [
      'campaign_id',
      'campaign_name',
      'adset_id',
      'adset_name',
      'ad_id',
      'ad_name',
      'creative_type',
      'ad_thumbnail_url',
      'primary_text',
      'headline',
      'call_to_action',
      'destination_url',
      'ads_level_assessment',
    ].forEach((field) => {
      if (acc[field] == null && row[field] != null) acc[field] = row[field];
    });
  });

  return [...grouped.values()]
    .map((row) => {
      const spend = Number(row.spend) || 0;
      const impressions = Number(row.impressions) || 0;
      const linkClicks = Number(row.link_clicks || row.clicks) || 0;
      const conversions = Number(row.conversions) || 0;
      const landingPageViews = Number(row.landing_page_views) || 0;
      const attributedRevenue = Number(row.attributed_revenue || row.revenue) || 0;
      const parentAdsetRevenue = Number(row.parent_adset_revenue) || 0;
      return {
        ...row,
        ctr: impressions > 0 ? round((linkClicks / impressions) * 100, 3) : null,
        cpc: linkClicks > 0 ? round(spend / linkClicks) : null,
        landing_page_view_conversion_rate:
          landingPageViews > 0 ? round((conversions / landingPageViews) * 100, 3) : null,
        roas: spend > 0 ? round(attributedRevenue / spend, 3) : null,
        attributed_revenue: attributedRevenue,
        ad_share_of_revenue:
          parentAdsetRevenue > 0 ? round(attributedRevenue / parentAdsetRevenue, 3) : null,
      };
    })
    .sort((a, b) => (Number(b.spend) || 0) - (Number(a.spend) || 0));
};

export const deriveAdsLevelFromRawRange = (entries = []) => {
  const rows = entries.flatMap((entry) => Array.isArray(entry?.rows) ? entry.rows : []);
  const aggregatedRows = aggregateAdsLevelRows(rows);
  if (!aggregatedRows.length) return null;

  return {
    totals: {
      ad_count: aggregatedRows.length,
      spend: round(aggregatedRows.reduce((sum, row) => sum + (Number(row.spend) || 0), 0)),
      attributed_revenue: round(aggregatedRows.reduce((sum, row) => sum + (Number(row.attributed_revenue) || 0), 0)),
      purchases: aggregatedRows.reduce((sum, row) => sum + (Number(row.conversions) || 0), 0),
    },
    rows: aggregatedRows,
  };
};
